import { Table } from 'components/core-ui/Table'
import s from './Employees.modules.scss'
import { useMemo, useState } from 'react'
import { EmployeeTableItem } from '../interfaces'
import { makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { useNotification } from 'hooks'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'
import { getColumns, getFilters } from './helpers'
import { ViewActionIcon } from 'icons'
import { useNavigate } from 'react-router-dom'

const Employees = () => {
  const [tableItems, setTableItems] = useState<EmployeeTableItem[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [shouldResetPage, setShouldResetPage] = useState<boolean>(false)

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const columns = useMemo(() => getColumns, [])

  const filters = useMemo(() => getFilters(), [])

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/employee-management/persons',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list || []))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `Error while fetching table data. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        orderBy="firstName"
        order="asc"
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        shouldResetPage={shouldResetPage}
        setShouldResetPage={setShouldResetPage}
        filters={filters}
        rowActions={[
          {
            label: 'Details',
            labelColor: 'white',
            typographyVariant: 'medium',
            backgroundColor: '#0970E6',
            desktopIcon: <ViewActionIcon />,
            onClick: (_e: React.MouseEvent<HTMLElement>, rowId: number) =>
              navigate(`/employeeManagement/employees/${rowId}`)
          }
        ]}
      />
    </div>
  )
}

export default Employees
